import { makeStyles } from "tss-react/mui";

const useStyle = makeStyles()(() => ({
  dialog: {
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255, 255, 255, 0.8)",
      backdropFilter: "blur(20px) saturate(180%)",
      borderRadius: "24px",
      padding: "40px",
      border: "1px solid rgba(255, 255, 255, 0.4)",
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
      width: "100%",
      maxWidth: "460px",
    },
  },
  dialogContent: {
    padding: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  iconWrapper: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(77, 18, 119, 0.05)",
    marginBottom: "24px",
    "& svg": {
      fontSize: "40px !important",
    },
  },
  dialogIcon: {
    width: "48px",
    height: "48px",
    objectFit: "contain",
  },
  headingStyle: {
    fontFamily: "Poppins",
    fontWeight: 700,
    fontSize: "22px",
    color: "#1a1a1a",
    marginBottom: "12px",
    textAlign: "center",
  },
  descriptionStyle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "15px",
    color: "#666",
    textAlign: "center",
    lineHeight: "1.6",
    marginBottom: "32px",
  },
  bottomBtnBar: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    gap: "16px",
    padding: 0,
    margin: 0,
  },
  saveBtn: {
    flex: 1,
    height: "48px",
    background: "linear-gradient(135deg, #4D1277 0%, #6A1BBC 100%)",
    color: "#fff",
    borderRadius: "12px",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "14px",
    textTransform: "none",
    boxShadow: "0 4px 12px rgba(77, 18, 119, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "linear-gradient(135deg, #3a0d5a 0%, #551496 100%)",
      boxShadow: "0 6px 16px rgba(77, 18, 119, 0.35)",
      transform: "translateY(-1px)",
    },
    "&:disabled": {
      background: "#e0e0e0",
      color: "#9e9e9e",
    },
  },
  cancelBtn: {
    flex: 1,
    height: "48px",
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    color: "#444",
    borderRadius: "12px",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "14px",
    textTransform: "none",
    border: "1px solid rgba(0, 0, 0, 0.05)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
      transform: "translateY(-1px)",
    },
  },
}));

export default useStyle;
